"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/@stardust-ui/react-component-event-listener/dist/commonjs/types.js
// module id = 6649
// module chunks = 0